import './supTripDetails.css';
import DetailsImageDisplay from '../../../components/detailsImageDisplay/DetailsImageDisplay';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import ReviewStars from '../../../components/reviewStars/ReviewStars';
import EmptyPage from '../../../components/empty-page/emptyPage';
import { useLocation, useNavigate } from 'react-router-dom';
import fetchTripDetails from '../supApprovalsFun/fetchTripDetails';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import Dialog from '../../../components/dialogModal/dialogModal';
import CharCount from '../../../components/charCount/CharCount';
import { handleApproveTrip, handleRejectTrip } from '../supApprovalsFun/approveReject';
import SupportTripDetialsTabs from '../../../components/support/supportTripDetails/SupportTripDetialsTabs';
import { buildFormDataFromAccommodation } from '../../../utils/accommodationPayload';
import ReviewSubmit from '../../accommodation/review/ReviewSubmit';

export default function SupApprovalDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const [packData, setPackData] = useState({});
    const [packDates, setPackDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [comment, setComment] = useState('');
    const packId = location.state.id;
    const type = location.state.selectedType;

    useEffect(() => {
        fetchTripDetails(type, packId, setLoading, setPackData, setPackDates);
        //eslint-disable-next-line
    }, []);

    const handleApprove = async () => {
        const res = await handleApproveTrip(type, packId, setLoading);
        if (res === 200) {
            navigate(-1);
        }
    };

    const handleReject = async () => {
        const res = await handleRejectTrip(type, packId, comment, setLoading);
        if (res === 200) {
            navigate(-1);
        }
    };

    const isCamp = type === 'camp';

    /*
     * ACCOMMODATION: this page used to only know how to render
     * trip-shaped data (days/nights, quickView.*, star rating) -
     * none of which exist on an Accommodation record, and
     * `packData?.quickView?.type[0]` would throw outright the
     * moment a camp pending-approval row was opened (quickView is
     * undefined, so `.type` is undefined, and indexing `[0]` on
     * that is not guarded by the optional chaining before it).
     * Reuses the same ReviewSubmit summary the accommodation
     * wizard's own Review step shows, in its read-only mode, so
     * this doesn't duplicate that rendering.
     */
    const accommodationFormData = isCamp ? buildFormDataFromAccommodation(packData) : null;

    const approveRejectActions = (
        <>
            <button type='button' className='approvalRejectBtn blueBtn' onClick={() => setRejectModal(true)}>
                Reject
            </button>
            <button type='button' className='approvalSubmitBtn blueBtn' onClick={handleApprove}>
                Approve
            </button>
        </>
    );

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {Object.keys(packData).length !== 0 ? (
                <>
                    <button className='backBtn' onClick={() => navigate(-1)}>
                        <img src={BackIcon} alt='back' />
                        Back to Approvals
                    </button>
                    {isCamp ? (
                        <>
                            <div className='supTripDetailsHeadingDiv'>
                                <h1 className='supDetailsImageDisplayName'>{packData?.title || 'N/A'}</h1>
                                <div>
                                    <div className='supTripBriefInfo'>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.organizerName || 'N/A'}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.propertyType || 'N/A'}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {[packData?.address?.city, packData?.address?.state]
                                                .filter(Boolean)
                                                .join(', ') || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <ReviewSubmit formData={accommodationFormData} readOnly actions={approveRejectActions} />
                        </>
                    ) : (
                        <>
                            <div className='supTripDetailsHeadingDiv'>
                                <h1 className='supDetailsImageDisplayName'>
                                    {packData?.title || 'N/A'}
                                    {/* <Share onClick={(e) => share(e)} /> */}
                                    {/* <button
                                        className="shareButton"
                                        onClick={(e) => share(e)}
                                    >
                                        Share
                                    </button> */}
                                </h1>
                                <div>
                                    <div className='supTripBriefInfo'>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.days + 'D/' + packData?.nights + 'N'}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packDates?.length !== 0 &&
                                                packDates[0]?.startDate.split('/').reverse().join('/')}{' '}
                                            Onwards
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.quickView?.startTime}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>{packData?.quickView?.stay}</span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>{packData?.quickView?.food}</span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.quickView?.type?.[0]}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.quickView?.difficulty}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails'>
                                            {packData?.organizerName || 'N/A'}
                                        </span>
                                        <span className='supTripDetailsDot'></span>
                                        <span className='supTripDetailsSubDetails alignCenter'>
                                            <ReviewStars rating={packData?.rating || 0} />
                                            <span>{packData?.rating || 0}</span>
                                            <p style={{ margin: 0 }}>({packData?.reviewCount || 0} Reviews)</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='supTripDetails'>
                                <DetailsImageDisplay imageData={packData.images} />
                                <div className='supTripDetailsTextBooking'>
                                    <div className='supTripDetailsText'>
                                        <SupportTripDetialsTabs tripDetailsData={packData} />
                                    </div>
                                </div>
                            </div>
                            <div className='supTripDetailsBtn'>{approveRejectActions}</div>
                        </>
                    )}
                </>
            ) : (
                <EmptyPage />
            )}
            {rejectModal && (
                <Dialog openModal={rejectModal} heading={'Reject Confirmation!'}>
                    <div className='dialogContent'>
                        <label>Comment</label>
                        <div className='commentArea'>
                            <textarea
                                className='rejectionComment'
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                            <CharCount string={comment ? comment : ''} min={10} limit={50} />
                        </div>
                        <div className='alignCenter'>
                            <button className='dialogActBtn submit' onClick={handleReject}>
                                Submit
                            </button>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setRejectModal(false);
                                    setComment('');
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}
